<template>
  <v-layout>
    <v-row>
      <v-col cols="12" md="3" xl="2">
        <v-card>
          <v-card-title>
            Filtry
          </v-card-title>
          <v-card-text>

          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="9" xl="10">
        <v-card>
          <v-card-title>
            Plany abonamentowe
          </v-card-title>
          <v-card-text>
            <div class="text-center">
              <v-btn
                  class="mx-2"
                  @click="refresh"
              >
                Odśwież
              </v-btn>
            </div>
            <data-table
                :headers="headers"
                :items="items"
                :options.sync="options"
                :server-items-length="total"
                :loading="loading"
                class="row-pointer"
                @click:row="(item) => $router.push({name: 'subscription-plan-details', params: { id: item.id }}).catch(()=>{})"
            >
              <template v-slot:item.order="{ item }">
                {{ item.order }}
              </template>
              <template v-slot:item.name="{ item }">
                <span v-html="formatEmpty(item.name, 'Brak', 'red--text')"/>
              </template>
              <template v-slot:item.available="{ item }">
                <v-switch
                    :input-value="mapBool(item.available, true)"
                    :label="false !== item.available ? 'Tak' : 'Nie'"
                    readonly
                    disabled
                />
              </template>
              <template v-slot:item.priceInPln="{ item }">
                <div style="white-space: nowrap">
                  <span v-if="0 === item.priceInPln" class="green--text">0,00</span>
                  <span v-if="0 !== item.priceInPln">{{ formatAmount(item.priceInPln) }}</span>
                  <span class="s-type">(subskrypcja miesięczna)</span>
                </div>
                <div style="white-space: nowrap">
                  <span v-if="0 === item.yearlyPriceInPln" class="green--text">0,00</span>
                  <span v-if="0 !== item.yearlyPriceInPln">{{ formatAmount(item.yearlyPriceInPln) }}</span>
                  <span class="s-type">(subskrypcja roczna)</span>
                </div>
              </template>
              <template v-slot:item.availableFrom="{ item }">
                {{ localDateTime(item.availableFrom, '') }}
              </template>
              <template v-slot:item.availableTo="{ item }">
                {{ localDateTime(item.availableTo, '') }}
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ localDateTime(item.createdAt, 'Brak') }}
              </template>
              <template v-slot:item.updatedAt="{ item }">
                {{ localDateTime(item.updatedAt, 'Nie modyfikowano') }}
              </template>
            </data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import api from '@/services/api';
import DataTable from "@/components/data-table/DataTable";
import filters from "@/mixins/filters";
import formatters from "@/mixins/formatters";
import {getDatatableParams, setDatatableOptions} from '@/utils/helpers';

export default {
  mixins: [
    filters,
    formatters,
  ],
  components: {
    DataTable,
  },
  data() {
    return {
      total: 0,
      items: [],
      loading: false,
      options: {},
      headers: [
        {text: 'Lp', value: 'order', sortable: false},
        {text: 'Nazwa', value: 'name', sortable: false},
        {text: 'Dostępny', value: 'available', sortable: false},
        {text: 'Cena za miesiąc (PLN)', value: 'priceInPln', sortable: false},
        //{text: 'Dostępny od', value: 'availableFrom', sortable: false},
        //{text: 'Dostępny do', value: 'availableTo', sortable: false},
        {text: 'Utworzono', value: 'createdAt', sortable: false},
        {text: 'Ost. aktualizacja', value: 'updatedAt', sortable: false},
      ],
      filters: {},
      editedIndex: -1,
    }
  },
  mounted() {
    const self = this;

    this.$root.$on('loadSubscriptionPlans', (options) => {
      self.load(options);
    });
  },
  watch: {
    options: {
      handler() {
        this.load();
        setDatatableOptions.call(this);
      },
      deep: true,
    },
  },
  methods: {
    appendFilters(params, filters) {
      if (!(filters instanceof Object)) {
        return;
      }

      this.appendStringFilterIfNonEmpty(params, 'name', filters.name);
      this.appendBoolFilterIfNonEmpty(params, 'available', filters.available, true);
      this.appendBoolFilterIfNonEmpty(params, 'notAvailable', filters.notAvailable, true);
    },
    formatEmpty(value, onEmptyHtml = 'Brak', onEmptyClasses = 'orange--text') {
      if (null !== value && '' !== value) {
        return value;
      }

      return `<em class="${onEmptyClasses}">${onEmptyHtml}</em>`;
    },
    load(options = {}) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      options = options || {};

      let filters = {};
      this.appendFilters(filters, options.filters || this.filters);
      this.filters = filters; // Remember them.

      const {page, itemsPerPage} = this.options;
      const params = {
        ...filters,
        offset: page > 1 ? itemsPerPage * (page - 1) : 0
      };

      if (-1 !== itemsPerPage) {
        params.limit = itemsPerPage;
      }

      api.get('/api/subscription/plan', {params})
          .then((response) => {
            this.items = response.data.items;
            this.total = response.data.total;

            if (options.onSuccess) {
              options.onSuccess();
            }
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się pobrać listy planów.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    mapBool(value, onNull = false) {
      if (null === value) {
        return onNull;
      }

      return !!value;
    },
    refresh() {
      const self = this;
      this.$root.$emit('loadSubscriptionPlans', {
        onSuccess: () => {
          self.$root.$emit('notify', {
            html: 'Lista została odświeżona.',
          });
        }
      });
    },
    stopRowClickPropagation(event) {
      // The following line is required to avoid triggering onRowClicked() method.
      event.cancelBubble = true;
      event.stopPropagation();
    },
  },
  created() {
    getDatatableParams.call(this);
    this.load();
  }
}
</script>

<style lang="css" scoped>
.s-type {
  padding-left: .25em;
  color:#99999999;
}
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>